import { Breadcrumbs, Button, FormControl, MenuItem, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { appointemt, patient, range, treatment } from "../../common/type";
import { getTreatments } from "../../services/get.service";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { takenTreatment } from "../../validations/Validation";
import { toast } from "react-toastify";
import { postTakenTreatment } from "../../services/post.service";

interface TakenTreatment {
    price: number;
    treatmentId: number;
    patientId: number;
    ranges: range[];
    appointment: appointemt;
}

// interface MyRange {
//     id: number;
//     value: number;
// }

const Index = (props: {patient: patient | null}) => {
    var date = new Date().toISOString().substring(0, 10)
    const [treatments, setTreatment] = useState<treatment[]>([])
    // const [myRange, setMyRanges] = useState<MyRange[]>([])
    const { patient } = props
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        getTreatments()
            .then((res) => {
                setTreatment(res.data)
            })
            .catch((err) => {
                console.log(err);
            })
    }, [])

    const { register, handleSubmit, formState: { errors }, watch } = useForm<TakenTreatment>({
        resolver: yupResolver(takenTreatment),
        defaultValues: {
            patientId: patient?.id
        }
    })

    const OnSubmit = (data: any) => {
        // data.ranges = myRange;
        setLoading(true)
        const load = toast.loading('Please wait...')

        postTakenTreatment(data)
            .then((res) => {
                toast.update(load, {
                    render: res.data,
                    type: "success",
                    theme: "colored",
                    autoClose: 2500,
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false);
                navigate("/patient");
            })
            .catch((err) => {
                toast.update(load, {
                    render: err?.response?.data?.detail,
                    theme: "colored",
                    autoClose: 5000,
                    type: "error",
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false);
            })
    }

    // var ranges: range[] = []
    // treatments?.filter((treatment) => {
    //     if (treatment.id === watch('treatmentId'))
    //         ranges = treatment.ranges;

    //     return treatment
    // })

    // const theChange = (e: any) => {
    //     var singleRange = {
    //         id: e.target?.name,
    //         value: e.target?.value
    //     }

    //     if (myRange.length === 0) {
    //         myRange.push(singleRange)
    //     }

    //     else {
    //         if (!myRange.some((my) => my.id.toString() === singleRange.id)) {
    //             myRange.push(singleRange)
    //         }
    //         else {
    //             myRange.find((my) => { if (my.id === singleRange.id) my.value = singleRange.value; return my })
    //         }
    //     }

    //     setMyRanges(myRange)
    // }

    return <>
        <Helmet><title>Add New Treatment</title></Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full lg:px-20 px-3 py-10 pt-5">
                    <Breadcrumbs className="pb-5 color: rgb(0 0 0)" aria-label="breadcrumb">
                        <Link
                            color="black"
                            to="/patient"
                            className=" hover:underline color: rgb(0 0 0)"
                        >
                            <Typography>Patient</Typography>
                        </Link>
                        <Typography className="text-black">Add New Treatment</Typography>
                    </Breadcrumbs>
                    <Typography variant="h5">Add New Treatment</Typography>
                    <form className="grid grid-cols-2 gap-3 py-5" onSubmit={handleSubmit(OnSubmit)} >
                        <FormControl>
                            <TextField size="small" label="Choose Treatment" select {...register('treatmentId')}
                                error={errors.treatmentId ? true : false}>
                                {
                                    treatments.length > 0 ?
                                        treatments.map((treatment) => (
                                            <MenuItem value={treatment.id}>{treatment.name}</MenuItem>
                                        ))
                                        :
                                        <MenuItem value="">Treatments is not loaded!</MenuItem>
                                }
                            </TextField>
                            <p className="text-sm text-red-700">{errors.treatmentId?.message}</p>
                        </FormControl>
                        <div className="grid grid-cols-3 gap-2">
                            <FormControl className="col-span-2">
                                <TextField size="small" type="number"
                                    inputProps={{
                                        min: 1,
                                        max: treatments.filter((tr) => tr.id === watch('treatmentId')).at(0)?.maxPrice,
                                        // step: ".01"
                                    }}
                                    label="Price"
                                    {...register('price')}
                                    error={errors.price ? true : false}
                                />
                                <p className="text-sm text-red-700">{errors.price?.message}</p>
                            </FormControl>
                            <div className="flex flex-col">
                                {/* <p>Min: {treatments.filter((tr) => tr.id === watch('treatmentId')).at(0)?.minPrice}</p> */}
                                <p>Max: {treatments.filter((tr) => tr.id === watch('treatmentId')).at(0)?.maxPrice}</p>
                            </div>
                        </div>
                        <FormControl>
                            <TextField size="small" type="date" defaultValue={date}  {...register('appointment.start')}
                                inputProps={{ min: date }} label="Appointment Starting Date"
                                error={errors.appointment?.start ? true : false}
                            />
                            <p className="text-sm text-red-700">{errors.appointment?.start?.message}</p>
                        </FormControl>
                        <FormControl>
                            <TextField size="small" type="date" defaultValue={date}  {...register('appointment.end')}
                                inputProps={{ min: date }} label="Appointment End Date"
                                error={errors.appointment?.end ? true : false}
                            />
                            <p className="text-sm text-red-700">{errors.appointment?.end?.message}</p>
                        </FormControl>
                        <FormControl>
                            <TextField size="small" type="number" inputProps={{ min: 1 }}  {...register('appointment.cycle')} label="Cycle"
                                error={errors.appointment?.cycle ? true : false}
                            />
                            <p className="text-sm text-red-700">{errors.appointment?.cycle?.message}</p>
                        </FormControl>
                        {/* {
                            ranges?.map((range) => (
                                <>
                                    <Slider min={range.min} max={range.max} step={0.1}
                                        marks={[{ value: (range.min + range.max) / 2, label: range.name }]}
                                        valueLabelDisplay="auto"
                                        onChange={(e) => theChange(e)}
                                        name={range.id.toString()}
                                    />
                                </>
                            ))
                        } */}
                        <Button disabled={loading} variant="contained" type="submit" className="col-span-2">Add</Button>
                    </form>
                </div>
            </div>
        </div >
    </>;
};

export default Index;
